import ComingSoon from "../Components/ComingSoon";


const AcademyPage = () => {
  return (
    <ComingSoon showWyzant={true} />
  )
};

export default AcademyPage;
